import { render, staticRenderFns } from "./CandidateFrontsheet.vue?vue&type=template&id=f20d2ce4&scoped=true"
import script from "./CandidateFrontsheet.vue?vue&type=script&lang=js"
export * from "./CandidateFrontsheet.vue?vue&type=script&lang=js"
import style0 from "./CandidateFrontsheet.vue?vue&type=style&index=0&id=f20d2ce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20d2ce4",
  null
  
)

export default component.exports